import React from 'react';
import CommentThreadCompactAvatar from './CommentThreadCompactAvatar';
import * as styles from './CommentThreadCompactAvatarStack.module.scss';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const COMMENT_FRAGMENT = gql(`
  fragment CommentThreadCompactAvatarStack_comment on PublicCommentFields {
    id
    author {
      ...CommentThreadCompactAvatar_user
    }
  }
`);

interface CommentThreadCompactAvatarStackProps {
  comments: DocumentType<typeof COMMENT_FRAGMENT>[];
  ring?: boolean;
}

const MAX_ITEMS_SHOWN = 3;
const CommentThreadCompactAvatarStack = ({
  comments,
  ring,
}: CommentThreadCompactAvatarStackProps) => {
  const overflowCount = comments.length - (MAX_ITEMS_SHOWN - 1);

  const slicedComments = [
    ...comments.slice(0, 2),
    ...(comments.length > 2 ? comments.slice(-1) : []),
  ];

  return (
    <div className={styles.container}>
      {slicedComments.map((item, i) => {
        if (overflowCount > 1 && i === 1) {
          return (
            <div className={styles.avatarContainer} key="overflow-count">
              <div className={styles.counter}>{overflowCount}</div>
            </div>
          );
        }

        return (
          <div className={styles.avatarContainer} key={item.id}>
            <CommentThreadCompactAvatar ring={ring} user={item.author} />
          </div>
        );
      })}
    </div>
  );
};

export default CommentThreadCompactAvatarStack;
